import React from "react";
import { Outlet } from "react-router-dom";
import Head from "./head/Head";
import Header from "./header/Header";
import Footer from "./footer/Footer";
import AppRoot from "./global/AppRoot";
import AppWrap from "./global/AppWrap";
import { ToastContainer } from "react-toastify";

const Layout = ({ title, ...props }) => {
  return (
    <>
      {" "}
      <Head title={!title && ""} />
      <AppRoot>
        <AppWrap>
          <Header fixed />
          <Outlet />
          <Footer />
          <ToastContainer autoClose={3500} position="top-center" />
        </AppWrap>
      </AppRoot>
    </>
  );
};
export default Layout;
